import "./offerpackage.css";
import * as React from "react";
import { useLocation } from "react-router-dom"; // Import the hook

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import PropTypes from "prop-types";

import OfferPackageMember from "./OfferPackageMember";
import OfferPackage from "./OfferPackage";

import { useNavigate } from "react-router-dom";

const drawerWidth = 292;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

function ParentOfferPackage() {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const location = useLocation(); // Access location
  const [value, setValue] = React.useState(0);
  React.useEffect(() => {
    // If tabIndex is passed in the location state, set it to the tab value
    if (location.state?.tabIndex !== undefined) {
      setValue(location.state.tabIndex);
    }
  }, [location.state]);
  const handleChangetab = (event, newValue) => {
    setValue(newValue);
  };

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  const tabStyle = (isActive) => ({
    textDecoration: "none",
    flexGrow: 1,
    textTransform: "none",
    fontWeight: "bold",
    marginRight: "10px",
    backgroundColor: isActive ? "#D8E2FF" : "inherit",
    borderRadius: "10px 10px 0px 0px",
    borderBottom: isActive ? "2px solid #005AC1" : "none",
    color: isActive ? "#005AC1" : "inherit",
  });
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f0f2f5" }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Box sx={{ mt: 8, mb: 4 }}>
        

          <Box sx={{ 
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            overflow: 'hidden'
          }}>
            <Tabs
              value={value}
              onChange={handleChangetab}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                px: 2,
                pt: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '& .MuiTabs-indicator': {
                  backgroundColor: appColors.evergreen,
                },
              }}
            >
              <Tab
                label="Offer Package Member"
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  color: value === 0 ? appColors.evergreen : '#64748b',
                  '&.Mui-selected': {
                    color: appColors.evergreen,
                  },
                  '&:hover': {
                    color: appColors.evergreen,
                  },
                }}
              />
              <Tab
                label="Offer Package"
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  color: value === 1 ? appColors.evergreen : '#64748b',
                  '&.Mui-selected': {
                    color: appColors.evergreen,
                  },
                  '&:hover': {
                    color: appColors.evergreen,
                  },
                }}
              />
            </Tabs>

            <Box sx={{ p: 3 }}>
              <TabPanel value={value} index={0}>
                <OfferPackageMember />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <OfferPackage />
              </TabPanel>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ParentOfferPackage;
